import React, { useEffect, useState } from 'react';
import { Download, X, Share } from 'lucide-react';
import { Button } from './ui/button';

const CHAVE = 'inn_install_prompt';
const DIAS_SEM_INSISTIR = 30;

const lerEstado = () => {
  try { return JSON.parse(localStorage.getItem(CHAVE) || '{}'); } catch { return {}; }
};
const gravarEstado = (e) => {
  try { localStorage.setItem(CHAVE, JSON.stringify(e)); } catch { /* noop */ }
};

const jaInstalado = () =>
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

const ehIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;

const InstallPrompt = () => {
  const [evento, setEvento] = useState(null);
  const [visivel, setVisivel] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if (jaInstalado()) return undefined;
    const est = lerEstado();
    if (est.instalado) return undefined;
    if (est.dispensadoEm && Date.now() - est.dispensadoEm < DIAS_SEM_INSISTIR * 86400000) return undefined;

    const aoDisponivel = (e) => {
      e.preventDefault();
      setEvento(e);
      setTimeout(() => setVisivel(true), 4000);
    };
    const aoInstalar = () => {
      gravarEstado({ ...lerEstado(), instalado: true });
      setVisivel(false);
    };

    window.addEventListener('beforeinstallprompt', aoDisponivel);
    window.addEventListener('appinstalled', aoInstalar);

    let t;
    if (ehIOS()) {
      setIos(true);
      t = setTimeout(() => setVisivel(true), 4000);
    }
    return () => {
      window.removeEventListener('beforeinstallprompt', aoDisponivel);
      window.removeEventListener('appinstalled', aoInstalar);
      clearTimeout(t);
    };
  }, []);

  const dispensar = () => {
    gravarEstado({ ...lerEstado(), dispensadoEm: Date.now() });
    setVisivel(false);
  };

  const instalar = async () => {
    if (!evento) return;
    evento.prompt();
    const { outcome } = await evento.userChoice;
    if (outcome === 'accepted') gravarEstado({ ...lerEstado(), instalado: true });
    else gravarEstado({ ...lerEstado(), dispensadoEm: Date.now() });
    setEvento(null);
    setVisivel(false);
  };

  if (!visivel || (!evento && !ios)) return null;

  return (
    <div role="dialog" aria-label="Instalar aplicativo"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:w-96 z-50 bg-white border border-slate-200 rounded-2xl shadow-xl p-4">
      <button onClick={dispensar} aria-label="Fechar" className="absolute top-3 right-3 text-slate-400 hover:text-slate-600">
        <X className="w-4 h-4" />
      </button>
      <div className="flex items-start gap-3 pr-5">
        <img src="/icon-192.png" alt="" className="w-12 h-12 rounded-xl flex-shrink-0" />
        <div className="min-w-0">
          <p className="font-bold text-slate-900 leading-tight">Instale o app In'Nova Envios</p>
          {ios ? (
            <p className="text-sm text-slate-600 mt-1">
              Toque em <Share className="inline w-4 h-4 -mt-0.5 text-[#2A5BC7]" /> <strong>Compartilhar</strong> e depois em
              <strong> "Adicionar à Tela de Início"</strong> para abrir como um aplicativo.
            </p>
          ) : (
            <p className="text-sm text-slate-600 mt-1">Acesse mais rápido, direto da sua área de trabalho ou tela inicial, sem abrir o navegador.</p>
          )}
        </div>
      </div>
      <div className="flex gap-2 mt-3 justify-end">
        <Button variant="ghost" onClick={dispensar} className="h-9 rounded-full text-slate-500">Agora não</Button>
        {!ios && (
          <Button onClick={instalar} className="inn-btn-primary h-9 rounded-full px-5">
            <Download className="w-4 h-4 mr-1.5" /> Instalar
          </Button>
        )}
      </div>
    </div>
  );
};

export default InstallPrompt;
